import StudentDashboardLayout from "@/components/Student/DashboardLayout";
import { useAuthContext } from "@/context/auth/AuthContext";
import axios from "axios";
import Link from "next/link";
import { useState } from "react";
import CourseWidgets from "@/components/Instructor/Dashboard-Section/widgets/CourseWidget";
import DataDisplay from "@/components/Common/DataFetcher";
import { connectToDatabase } from "@/components/Server/Database/MongoDB";
import guest from "../../../public/images/icons/guest.png";
import advisor from "../../../public/images/icons/advisor.webp";
import resident from "../../../public/images/icons/resident.png";
import lecturer from "../../../public/images/icons/lecturer.png";
import Image from "next/image";
const SubjectSystemSelector = ({ info }) => {
  const [lecturers, setLecturers] = useState([]);
  const [advisors, setAdvisors] = useState([]);
  const [residents, setResidents] = useState([]);
  const [guests, setGuests] = useState([]);
  const { user } = useAuthContext();

  const tabs = [
    {
      id: "lecturers",
      selected: true,
      displayName: "Lecturers",
      component: (
        <DataDisplay
          user={user}
          empty={lecturers.length === 0}
          fetchData={async (
            currentPage,
            limit,
            search,
            searchBy,
            setPages,
            setError,
            setLoading
          ) => {
            try {
              setLoading(true);
              const response = await axios.get(
                `/api/data?collection=faculty&page=${currentPage}&limit=${limit}&search=Lecturer,${search}&searchBy=type,${searchBy}`
              );

              if (response.status === 200) {
                setLecturers(response.data.data);
                setPages(response.data.pages);
                setError(null);
              } else {
                setError(
                  response.data.message ||
                    "An error occurred during data fetching."
                );
              }
            } catch (err) {
              setError("Fetching data failed. Please try again later.");
            } finally {
              setLoading(false);
            }
          }}
          setData={setLecturers}
          config={{
            empty: {
              image: {
                src: lecturer,
                width: 100,
                height: 100,
              },
              title: "No Lecturers",
              subtitle: "Currently there are no lecturers available",
            },
            searchBy: "firstName",
          }}
        >
          {lecturers?.map((slide, index) => (
            <div className="col-md-6 col-12" key={`course-enrolled-${index}`}>
              <div className="card rbt-card h-100 shadow-sm">
                {/* Profile image */}
                <div className="card-img-top position-relative">
                  <Image
                    src={slide.photoURL}
                    alt={`${slide.firstName} ${slide.lastName}`}
                    className="w-100 rounded-top"
                    width={400}
                    height={220}
                    style={{ objectFit: "cover" }}
                  />
                  <span className="badge bg-primary position-absolute top-0 end-0 m-2">
                    {slide.code}
                  </span>
                </div>

                {/* Body */}
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title mb-1">
                    {slide.prefix} {slide.firstName} {slide.lastName}
                  </h5>
                  <p className="text-muted mb-2">{slide.type}</p>

                  <div className="mt-auto">
                    <p className="small text-muted mb-2">
                      <strong>Qualification:</strong> {slide.qualification}
                    </p>

                    <button className="rbt-btn btn-sm btn-primary w-100">
                      Contact Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </DataDisplay>
      ),
    },
    {
      id: "advisors",
      selected: false,
      displayName: "Academic Medical Advisors",
      component: (
        <DataDisplay
          user={user}
          fetchData={async (
            currentPage,
            limit,
            search,
            searchBy,
            setPages,
            setError,
            setLoading
          ) => {
            try {
              setLoading(true);
              const response = await axios.get(
                `/api/data?collection=faculty&page=${currentPage}&limit=${limit}&search=Academic Medical Advisor,${search}&searchBy=type,${searchBy}`
              );

              if (response.status === 200) {
                setAdvisors(response.data.data);
                setPages(response.data.pages);
                setError(null);
              } else {
                setError(
                  response.data.message ||
                    "An error occurred during data fetching."
                );
              }
            } catch (err) {
              setError("Fetching data failed. Please try again later.");
            } finally {
              setLoading(false);
            }
          }}
          empty={advisors.length === 0}
          setData={setAdvisors}
          config={{
            empty: {
              image: {
                src: advisor,
                width: 100,
                height: 100,
              },
              title: "No advisors",

              subtitle: "Currently there are no advisors available",
            },
            searchBy: "firstName",
          }}
        >
          {advisors?.map((slide, index) => {
            return (
              <div className="col-md-6 col-12" key={`advisor-${index}`}>
                <div className="card rbt-card h-100 shadow-sm">
                  {/* Profile image */}
                  <div className="card-img-top position-relative">
                    <Image
                      src={slide.photoURL}
                      alt={`${slide.firstName} ${slide.lastName}`}
                      className="w-100 rounded-top"
                      width={400}
                      height={220}
                      style={{ objectFit: "cover" }}
                    />
                    <span className="badge bg-primary position-absolute top-0 end-0 m-2">
                      {slide.code}
                    </span>
                  </div>

                  {/* Body */}
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title mb-1">
                      {slide.prefix} {slide.firstName} {slide.lastName}
                    </h5>
                    <p className="text-muted mb-2">{slide.type}</p>
                    <p className="card-text">{slide.about?.slice(0, 80)}...</p>

                    <div className="mt-auto">
                      <p className="small text-muted mb-2">
                        <strong>Qualification:</strong> {slide.qualification}
                      </p>

                      <button className="rbt-btn btn-sm btn-primary w-100">
                        Contact Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </DataDisplay>
      ),
    },
    {
      id: "residents",
      selected: false,
      displayName: "Residents",
      component: (
        <DataDisplay
          user={user}
          fetchData={async (
            currentPage,
            limit,
            search,
            searchBy,
            setPages,
            setError,
            setLoading
          ) => {
            try {
              setLoading(true);
              const response = await axios.get(
                `/api/data?collection=faculty&page=${currentPage}&limit=${limit}&search=Residents,${search}&searchBy=type,${searchBy}`
              );

              if (response.status === 200) {
                setResidents(response.data.data);
                setPages(response.data.pages);
                setError(null);
              } else {
                setError(
                  response.data.message ||
                    "An error occurred during data fetching."
                );
              }
            } catch (err) {
              setError("Fetching data failed. Please try again later.");
            } finally {
              setLoading(false);
            }
          }}
          empty={residents.length === 0}
          setData={setResidents}
          config={{
            empty: {
              image: {
                src: resident,
                width: 100,
                height: 100,
              },
              title: "No Residents",
              subtitle: "Currently there are no residents available",
            },
            searchBy: "firstName",
          }}
        >
          {residents?.map((slide, index) => (
            <div className="col-md-4 col-12" key={`course-enrolled-${index}`}>
              <CourseWidgets
                data={{
                  ...slide,
                  displayName: `${slide.prefix} ${slide.firstName} ${slide.lastName}`,
                  shortDescription: slide.about,
                }}
                href={`/#`}
                courseStyle="two"
                isProgress={false}
                isCompleted={false}
                isEdit={false}
                showDescription={true}
                showAuthor={false}
                button={slide.email}
              />
            </div>
          ))}
        </DataDisplay>
      ),
    },
    {
      id: "guests",
      selected: false,
      displayName: "Guests",
      component: (
        <DataDisplay
          user={user}
          fetchData={async (
            currentPage,
            limit,
            search,
            searchBy,
            setPages,
            setError,
            setLoading
          ) => {
            try {
              setLoading(true);
              const response = await axios.get(
                `/api/data?collection=faculty&page=${currentPage}&limit=${limit}&search=Guests,${search}&searchBy=type,${searchBy}`
              );

              if (response.status === 200) {
                setGuests(response.data.data);
                setPages(response.data.pages);
                setError(null);
              } else {
                setError(
                  response.data.message ||
                    "An error occurred during data fetching."
                );
              }
            } catch (err) {
              setError("Fetching data failed. Please try again later.");
            } finally {
              setLoading(false);
            }
          }}
          empty={guests.length === 0}
          setData={setGuests}
          config={{
            empty: {
              image: {
                src: guest,
                width: 100,
                height: 100,
              },
              title: "No Guests",
              subtitle: "Currently there are no guests available",
            },
            searchBy: "firstName",
          }}
        >
          {guests?.map((slide, index) => (
            <div className="col-md-4 col-12" key={`course-enrolled-${index}`}>
              <CourseWidgets
                data={{
                  ...slide,
                  displayName: `${slide.prefix} ${slide.firstName} ${slide.lastName}`,
                  shortDescription: slide.about,
                }}
                href={`/#`}
                courseStyle="two"
                isProgress={false}
                isCompleted={false}
                isEdit={false}
                showDescription={true}
                showAuthor={false}
                button={slide.email}
              />
            </div>
          ))}
        </DataDisplay>
      ),
    },
  ];

  return (
    <StudentDashboardLayout brand={JSON.parse(info)} sidebar={true}>
      <div className="rbt-dashboard-content bg-color-white rbt-shadow-box">
        <div className="advance-tab-button mb--30">
          <ul
            className="nav nav-tabs tab-button-style-2 justify-content-start"
            id="myTab-4"
            role="tablist"
          >
            {tabs.map((tab, index) => {
              return (
                <li key={tab.id} role="presentation">
                  <Link
                    href="#"
                    className={`tab-button ${tab.selected ? "active" : ""}`}
                    id={tab.id}
                    data-bs-toggle="tab"
                    data-bs-target={`#${tab.id}-${index}`}
                    role="tab"
                    aria-controls={`${tab.id}-${index}`}
                    aria-selected={tab.selected}
                  >
                    <span className="title">{tab.displayName}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="tab-content">
          {tabs.map((tab, index) => {
            return (
              <div
                key={`${tab.id}-${index}`}
                className={`tab-pane fade ${tab.selected ? "active show" : ""}`}
                id={`${tab.id}-${index}`}
                role="tabpanel"
                aria-labelledby={tab.id}
              >
                {tab.component}
              </div>
            );
          })}
        </div>
      </div>
    </StudentDashboardLayout>
  );
};

export const getServerSideProps = async (context) => {
  const domainName = context.req ? context.req.headers.host : null;

  const { db } = await connectToDatabase();

  const info = await db.collection("partners").findOne({
    key: process.env.DEFAULT || domainName,
  });

  if (!info) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      info: JSON.stringify(info),
    },
  };
};
export default SubjectSystemSelector;
